import { useState, useEffect } from "react"
import { FormSectionWrapper } from "../FormSectionWrapper"
import { AdditionalReferences } from "./Sections/AdditionalReferences"
import { BillingDetails } from "./Sections/BillingDetails"
import { PackageAndShipmentDetails } from "./Sections/PackageAndShipmentDetails"
import { RecipientInformation } from "./Sections/RecipientInformation"
import { SenderInformation } from "./Sections/SenderInformation"
import { Shortcuts } from "./Sections/Shortcuts"
import { GetCountries, GetState, GetCity } from 'react-country-state-city';

export const ReturnShipmentDetails = ({ formik, getSpecialServices, specialServicesLoading, tabKey }) => {
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);

    useEffect(() => {
        const getCountries = async () => {
            const countries = await GetCountries();
            setCountries(countries);
            setStatesDropdown(countries);
        }
        const setStatesDropdown = async (countries) => {
            const defaultCountry = countries.find((c) => c.iso2 === 'US');
            const statesData = await GetState(defaultCountry.id);
            setStates(statesData);
        }

        getCountries();
    }, []);

    const handleCountryChange = async (e) => {
        formik.handleChange(e);
        setCities([]);
        const selectedCountry = countries.find((c) => c.iso2 === e.target.value);
        if (!selectedCountry) return setStates([]);
        const statesData = await GetState(selectedCountry.id);
        setStates(statesData);
        formik.setFieldValue('returnData.stateProvince', '');
        formik.setFieldValue('returnData.city', '');
    }

    const handleStateChange = async (e) => {
        formik.handleChange(e);
        const selectedState = states.find((s) => s.state_code === e.target.value);
        if (!selectedState) return setCities([]);
        const selectedCountry = countries.find((c) => c.iso2 === formik.values.returnData.country);
        const citiesData = await GetCity(selectedCountry.id, selectedState.id);
        setCities(citiesData);
        formik.setFieldValue('returnData.city', '');
    }

    return (
        <>
            <div className='form-grid'>
                <div>
                    <FormSectionWrapper title='Return package to'>
                        <SenderInformation formik={formik} isReturnShipmentTab={true} />
                    </FormSectionWrapper>
                    <FormSectionWrapper title='Return package from'>
                        <RecipientInformation
                            formik={formik}
                            countries={countries}
                            states={states}
                            cities={cities}
                            handleCountryChange={handleCountryChange}
                            handleStateChange={handleStateChange}
                            isReturnShipmentTab={true}
                            tabKey={tabKey}
                        />
                    </FormSectionWrapper>
                </div>
                <div>
                    <FormSectionWrapper title='Package and shipment details'>
                        <PackageAndShipmentDetails
                            formik={formik}
                            isReturnShipmentTab={true}
                        />
                    </FormSectionWrapper>
                    <FormSectionWrapper title='Billing details'>
                        <BillingDetails formik={formik} isReturnShipmentTab={true} />
                    </FormSectionWrapper>
                    {formik.values.returnData.returnLabelType === 'GROUND_CALL_TAG' ? null :
                        <FormSectionWrapper title='Additional references'>
                            <AdditionalReferences formik={formik} isReturnShipmentTab={true} />
                        </FormSectionWrapper>}
                </div>
                <div>
                    {formik.values.returnData.returnLabelType === 'GROUND_CALL_TAG' ? null :
                        <FormSectionWrapper title='Shortcuts'>
                            <Shortcuts
                                formik={formik}
                                getSpecialServices={getSpecialServices}
                                specialServicesLoading={specialServicesLoading}
                                isReturnShipmentTab={true}
                            />
                        </FormSectionWrapper>}
                </div>
            </div>
        </>
    )
}